// extracted by mini-css-extract-plugin
export default {"header":"validEvent_header__4hcWq","adminButtons":"validEvent_adminButtons__IU+Vz"};